// extracted by mini-css-extract-plugin
module.exports =  {"container":"_0d624b9a27--container--izJBY","cursor_pointer":"_0d624b9a27--cursor_pointer--jM4Gv"};